import React, { FC } from "react";
import styled from "styled-components";
import { wpdColor } from "../../styles/theme";
import { LeaderboardInterface } from "../../../fake-data/dashboardData";
import PercentageIndicatorLine from "../PercentageIndicatorLine";
import { SmallText } from "../../styles/Text";

const LeaderboardContainer = styled.div`
  display: block;
  max-height: 180px;
  overflow-x: hidden;
  overflow-y: scroll;
  margin-right: 2px;
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
    background: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-corner {
    background: #eee;
  }
`;

const LeaderboardEntry = styled.div`
  display: block;
  display: flex;
  flex-direction: row;
`;

const LeaderboardEntryCell = styled.div`
  flex: 1;
`;

const limitCharacters = (text: string) =>
  text.length > 21 ? text.substr(0, 21) + "..." : text;

function getColor(percentage: number) {
  switch (true) {
    case percentage <= 10:
      return wpdColor.quinary;
    case percentage <= 25:
      return wpdColor.quaternary;
    case percentage <= 50:
      return wpdColor.primaryLight;
    case percentage <= 80:
      return wpdColor.primary;
    case percentage <= 94:
      return wpdColor.tertiary;
    default:
      return wpdColor.primaryDark;
  }
}

const Leaderboard: FC<LeaderboardInterface> = ({ items }) => {
  const sortedItems = items.length
    ? items.sort((a, b) => (a.percentage < b.percentage ? 1 : -1))
    : [];

  return (
    <LeaderboardContainer>
      {sortedItems?.map(({ tag, percentage, active }, index) =>
        active ? (
          <LeaderboardEntry key={index}>
            <LeaderboardEntryCell style={{ flex: 5 }}>
              <SmallText>{tag ? limitCharacters(tag) : ""}</SmallText>
            </LeaderboardEntryCell>
            <LeaderboardEntryCell
              style={{ flex: 4, alignItems: "flex-end", paddingRight: "10px" }}
            >
              <PercentageIndicatorLine
                percentage={percentage}
                color={getColor(percentage)}
              ></PercentageIndicatorLine>
            </LeaderboardEntryCell>
            <LeaderboardEntryCell style={{ flex: 1, alignItems: "flex-end" }}>
              <SmallText>{percentage}%</SmallText>
            </LeaderboardEntryCell>
          </LeaderboardEntry>
        ) : (
          ""
        )
      )}
    </LeaderboardContainer>
  );
};

export default Leaderboard;
